export default __webpack_public_path__ + "static/steffenM-22bebe0f370cfaa746a70d22c422946c.png";